import ResponsiveHelper from "../utils/ResponsiveHelper";
import fullpage from "fullpage.js";
import Swiper from "swiper/bundle";
import CustomCursorTownClub from "../utils/CustomCursorTownClub";
import ScrollFunction from "../utils/ScrollFunction";

export default class Homepage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initResponsiveHelper();
    this.initCustomCursor();
    this.initDiningSlider();
    this.handleBottomSectionElementsShowHide();

    let viewPort = this.rHelper.getBreakpoint();
    if (viewPort != "xs" && viewPort != "sm" && viewPort != "md") {
      this.changeSectionIDTags();
      this.initFullpageHandle();
    } else {
      // scrollAnimation();
      this.initScroll();
      this.initScrollToView();
    }
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    this.lastViewportWidth = this.rHelper.getViewportWidth();
    window.addEventListener("onBreakpointChange", (e) => {
      // console.log(e.detail);
      let currentViewportWidth = this.rHelper.getViewportWidth();
      if (
        currentViewportWidth < this.lastViewportWidth &&
        currentViewportWidth < 768
      ) {
        //destroy
        this.desktroyFullpage();
        this.fullPageInstance = undefined;
        this.restoreSectionIDTags();
        // scrollAnimation();
        this.initScroll();
        this.initScrollToView();
      }
      if (
        currentViewportWidth > this.lastViewportWidth &&
        currentViewportWidth >= 768
      ) {
        if (this.fullPageInstance == undefined) {
          this.changeSectionIDTags();
          this.initFullpageHandle();
        }
      }
      this.lastViewportWidth = currentViewportWidth;
    });
  }

  changeSectionIDTags() {
    let sections = this.dom.querySelectorAll("section");
    for (let sec of sections) {
      if (sec.getAttribute("id") != undefined) {
        let value = sec.getAttribute("id");
        sec.removeAttribute("id");
        sec.setAttribute("data-id", value);
      }
    }
  }

  restoreSectionIDTags() {
    let sections = this.dom.querySelectorAll("section");
    for (let sec of sections) {
      if (sec.getAttribute("data-id") != undefined) {
        let value = sec.getAttribute("data-id");
        sec.removeAttribute("data-id");
        sec.setAttribute("id", value);
      }
    }
  }

  initFullpageHandle() {
    this.fullPageInstance = new fullpage("#townClub-Onepage", {
      licenseKey: "3YK28-5NCA7-8AVKK-2JY8I-MYECN",
      anchors: [
        "pageTop",
        // "BookAVisit",
        "About",
        "AboutMore",
        "Dining",
        "Events",
        "Happenings",
        "Patronship",
        "Booking",
        "Contact",
      ],
      // navigation: true,

      responsiveWidth: 768,
      keyboardScrolling: true,
      autoScrolling: true,
      scrollOverflow: true,
      normalScrollElements: ".scrollable-content",
      fitToSection: true,
      fitToSectionDelay: 100,

      // afterReBuild: function () {
      //   console.log("fullPage.js has manually being re-builded");
      // },
      // on: {
      //   reachEnd: function () {
      //     setTimeout(function () {
      //       fullpage_api.setAllowScrolling(true);
      //     }, 100);
      //   },
      // },

      onLeave: (origin, destination, direction, trigger) => {
        console.log(trigger);
      },
    });

    let modalEls = document.querySelectorAll(".modal");
    for (let [i, modalEl] of modalEls.entries()) {
      modalEl.addEventListener("show.bs.modal", (e) => {
        fullpage_api.setAllowScrolling(false);
        // fullpage_api.reBuild();
        this.diningSlider.autoplay.stop();
      });
      modalEl.addEventListener("shown.bs.modal", (e) => {
        fullpage_api.setAllowScrolling(false);
        // fullpage_api.reBuild();
        this.diningSlider.autoplay.stop();
        // this.desktroyFullpage();
        // fullpage_api.destroy("all");
      });
      modalEl.addEventListener("hide.bs.modal", (e) => {
        fullpage_api.setAllowScrolling(true);
        // fullpage_api.reBuild();
        this.diningSlider.autoplay.start();
        // fullpage_api.reBuild();
        // this.changeSectionIDTags();
        // this.initFullpageHandle();
      });
    }
  }

  desktroyFullpage() {
    if (this.fullPageInstance !== undefined) {
      fullpage_api.destroy("all");
    }
  }

  initCustomCursor() {
    let dom = document.querySelector(".page-wrapper");
    if (dom != undefined) {
      let customCursorTownClub = new CustomCursorTownClub(dom, "thisshow");

      customCursorTownClub.addModifierClass(
        document.querySelectorAll("[js-cursor-default]"),
        "default"
      );
      customCursorTownClub.addModifierClass(
        document.querySelectorAll("[js-no-cursor]"),
        "no-cursor"
      );
      customCursorTownClub.addModifierClass(
        document.querySelectorAll("a"),
        // "shrink"
        "pointer"
      );
      customCursorTownClub.addModifierClass(
        document.querySelectorAll(".another-link"),
        // "shrink"
        "pointer"
      );
      customCursorTownClub.addModifierClass(
        document.querySelectorAll("[js-pointer]"),
        // "shrink"
        "pointer"
      );
      customCursorTownClub.addModifierClass(
        document.querySelectorAll("[js-cursor-control]"),
        // "shrink"
        "open"
      );
      customCursorTownClub.addModifierClass(
        document.querySelectorAll("[js-threecol-cursor]"),
        "arrow"
      );

      let modalEls = document.querySelectorAll(".modal");
      for (let [i, modalEl] of modalEls.entries()) {
        modalEl.addEventListener("show.bs.modal", (e) => {
          customCursorTownClub.addModifierClass(
            document.querySelectorAll("[js-cursor-close]"),
            "close"
          );
        });
        modalEl.addEventListener("hide.bs.modal", (e) => {
          let cursor = document.querySelector("[js-cursor]");
          cursor.classList.remove("close");
        });
      }
      customCursorTownClub.addModifierClass(
        document.querySelectorAll("[js-hide-custom]"),
        "hide-custom"
      );
    }
  }
  initScroll() {
    this.scroll = new ScrollFunction();
  }
  resize() {
    // console.log("resize from Homepage.js");.
    // this.initScrollToView();
  }
  initDiningSlider() {
    this.diningSlider = new Swiper(".initDiningSwiper", {
      allowTouchMove: false,
      // loop: true,
      speed: 1500,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: ".swiper-button-next.dining-slider--btn_next",
        prevEl: ".swiper-button-prev.dining-slider--btn_prev",
      },
      on: {
        init: this.slidesTransition,
        slideChangeTransitionStart: this.slidesTransition,
        // transitionStart: this.slidesTransition,
      },
    });

    this.eventSlider = new Swiper(".initEventSwiper", {
      allowTouchMove: false,
      speed: 1500,
      autoplay: {
        delay: 4000,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      on: {
        init: this.eventTransition,
        slideChangeTransitionStart: this.eventTransition,
      },
    });
  }

  slidesTransition() {
    let slides = document.querySelectorAll(".dining-slider--item");
    for (let [i, sl] of slides.entries()) {
      let activeSlides = sl.classList.contains("swiper-slide-active");
      // console.log(activeSlides);
      if (activeSlides) {
        sl.classList.add("triggerChange");
      } else {
        sl.classList.remove("triggerChange");
      }
    }
  }
  eventTransition() {
    let slides = document.querySelectorAll(".events-slider--item");
    for (let [i, sl] of slides.entries()) {
      let activeSlides = sl.classList.contains("swiper-slide-active");
      // console.log(activeSlides);
      if (activeSlides) {
        sl.classList.add("triggerChange");
      } else {
        sl.classList.remove("triggerChange");
      }
    }
  }
  initScrollToView() {
    let nav = document.querySelector("[js-handle-scrollto]");
    let navItems = nav.querySelectorAll("[js-menu-item]");
    for (let [i, item] of navItems.entries()) {
      item.addEventListener("click", (e) => {
        this.scrollToView(e);
        const location = window.location.toString().split("#")[0];
        let url = item.getAttribute("href");
        // history.replaceState(null, null, location + "#" + url);
        history.replaceState(null, null, location + url);
      });
    }
  }

  scrollToView(e) {
    let elements = document.getElementById(e.target.dataset.target);
    if (elements != null) {
      e.preventDefault();
      elements.scrollIntoView({
        behavior: "smooth",
      });
    }
  }

  handleBottomSectionElementsShowHide() {
    const arrow = document.querySelector("[js-scroll-arrow-icon]");
    const navbg = document.querySelector("[js-navbg]");
    const bottomSection = document.querySelector("[js-control-bottom]");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        arrow.classList.toggle("menuopen", entry.isIntersecting);
        navbg.classList.toggle("hide-gradient", entry.isIntersecting);
      });
    });
    observer.observe(bottomSection);
  }
}
